// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"195":"d67bd55d","310":"747910fc"}[chunkId] + ".chunk.css";
};